var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCategoryEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 387,
    viewBox: "0 0 372 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.976 386.011C272.964 386.011 345.918 313.057 345.918 222.748C345.918 132.439 272.964 59.4844 182.976 59.4844C92.9885 59.4844 20.0342 132.439 20.0342 222.748C20.0342 313.057 92.9885 386.011 182.976 386.011Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1006 117.012H294.819C304.139 117.012 311.209 124.082 311.209 133.402V280.275C311.209 289.595 304.139 296.666 294.819 296.666H63.1006C53.7804 296.666 46.71 289.595 46.71 280.275V133.402C46.71 124.082 54.4232 117.012 63.1006 117.012Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.709 211.179V283.49C315.709 292.81 308.317 300.523 298.675 300.523H60.5295C51.2093 300.523 43.4961 292.81 43.4961 283.49V205.072",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.709 211.179V283.49C315.709 292.81 308.317 300.523 298.675 300.523H60.5295C51.2093 300.523 43.4961 292.81 43.4961 283.49V205.072",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M295.462 170.684H220.258C212.866 170.684 205.795 173.255 200.332 177.754L180.727 193.823C175.264 198.323 168.193 200.894 160.801 200.894H75.9559C67.2785 200.894 60.208 207.964 60.208 216.642C60.208 217.284 60.208 218.249 60.5294 218.891L76.2772 301.809C77.5628 309.522 83.9905 315.307 92.0251 315.307H273.607C281.321 315.307 288.07 309.843 289.355 302.13L311.209 188.681C312.816 180.004 307.031 172.291 298.354 170.684C297.068 170.684 296.104 170.684 295.462 170.684Z",
    fill: "#E4DAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3241_36750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.206 148.507H231.505C221.864 148.507 212.865 151.721 205.473 157.827L179.762 178.717C172.692 184.502 163.372 188.037 153.73 188.037H43.174C31.9255 188.037 22.9268 197.357 22.9268 208.284C22.9268 209.249 22.9268 210.213 23.2481 211.177L43.4954 319.484C45.1023 329.768 53.7797 337.16 63.7426 337.16H300.282C310.566 337.16 318.922 330.089 320.529 319.805L349.132 171.647C351.06 160.398 343.668 150.435 332.42 148.186C331.456 148.507 330.17 148.507 329.206 148.507Z",
    fill: "url(#paint0_linear_3241_36750)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.234 260.674C146.019 260.674 150.839 255.853 150.839 250.069C150.839 244.284 146.019 239.463 140.234 239.463C134.449 239.463 129.628 244.284 129.628 250.069C129.628 255.853 134.449 260.674 140.234 260.674Z",
    fill: "#15112D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222.828 260.348C228.613 260.348 233.434 255.527 233.434 249.742C233.434 243.957 228.613 239.137 222.828 239.137C217.043 239.137 212.223 243.957 212.223 249.742C212.223 255.849 217.043 260.348 222.828 260.348Z",
    fill: "#15112D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.955 329.769C343.669 335.233 341.741 341.017 339.491 345.838C333.385 357.729 323.744 367.05 311.852 373.156C299.64 379.262 285.177 381.833 270.715 378.619C236.648 371.549 214.794 338.125 221.865 304.058C228.935 269.991 262.038 247.816 296.104 255.208C308.317 257.779 318.923 263.885 327.922 272.241C343.027 287.346 349.454 309.2 344.955 329.769Z",
    fill: "#7647EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.495 311.451H289.033V296.989C289.033 294.096 286.783 291.525 283.569 291.525C280.677 291.525 278.106 293.775 278.106 296.989V311.451H263.643C260.751 311.451 258.18 313.701 258.18 316.915C258.18 320.129 260.429 322.378 263.643 322.378H278.106V336.841C278.106 339.733 280.355 342.304 283.569 342.304C286.462 342.304 289.033 340.054 289.033 336.841V322.378H303.495C306.387 322.378 308.958 320.129 308.958 316.915C308.958 313.701 306.387 311.451 303.495 311.451Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M168.513 184.502C156.944 162.005 154.373 135.009 162.086 110.584C169.478 86.1583 187.154 65.2683 209.008 53.3771C215.757 49.8418 223.47 46.9494 231.183 46.628C238.897 46.3066 247.253 48.8777 252.395 55.3054C257.537 61.0903 258.501 70.7318 254.323 77.1595C249.824 83.2658 240.825 85.8369 233.433 83.9086C221.542 81.6589 211.9 72.3387 209.008 61.0903C206.115 49.8418 209.972 36.6651 218.971 29.2732C224.756 24.1311 232.79 21.2386 240.182 18.9889C276.177 8.38322 315.386 7.09768 352.024 15.1323",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M191.653 271.92H171.728V276.741H191.653V271.92Z",
    fill: "#15112D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M371.308 6.77788C370.986 11.5986 370.665 16.098 367.13 17.0622C363.594 18.0263 361.988 14.8125 359.738 10.3131C357.488 6.13511 358.774 1.63573 362.63 0.671575C366.166 -0.292578 371.95 0.992959 371.308 6.77788Z",
    fill: "#DAE2EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M367.452 29.9162C368.416 24.1312 369.38 20.9174 366.166 19.3105C362.631 17.7035 360.381 20.596 356.525 24.4526C353.311 27.9878 355.239 33.13 358.453 34.7369C362.31 36.6652 366.488 34.7369 367.452 29.9162Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371.952 19.3114C371.63 21.5611 370.023 23.1681 367.774 23.4894C366.809 23.4894 365.845 23.4894 364.56 23.4894C360.06 22.8467 356.525 19.9542 356.846 17.0618C357.168 14.1693 361.346 12.5624 366.488 13.2051C367.452 13.2051 368.416 13.5265 369.059 13.8479C370.987 14.4907 372.273 16.7404 371.952 19.3114C371.952 18.9901 371.952 19.3114 371.952 19.3114Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2861 109.621C13.2861 104.157 13.2861 98.6935 17.1427 97.0866C21.3207 95.4796 23.5704 99.3362 26.7843 104.8C29.6767 109.621 28.3912 114.763 24.2132 116.37C20.678 117.977 13.2861 117.012 13.2861 109.621Z",
    fill: "#DAE2EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5352 82.6228C14.8924 89.3719 13.9282 93.2285 18.1062 94.8354C22.2842 96.4424 24.5339 92.9071 28.7119 87.765C31.9258 83.2656 29.6761 77.4807 25.4981 75.8737C21.3201 74.2668 16.1779 77.1593 15.5352 82.6228Z",
    fill: "#DAE2EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12 95.4817C12 92.9107 13.9283 90.9823 16.178 90.661C17.1422 90.3396 18.4277 90.3396 19.7132 90.661C24.8554 90.9823 29.3548 93.8748 29.0334 97.0886C28.712 100.302 24.534 102.552 19.0705 101.909C18.1063 101.909 17.1422 101.588 16.178 101.267C13.6069 100.945 12 98.3742 12 95.4817Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8535 96.4434C67.5989 96.4434 129.948 116.048 130.912 188.038",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3241_36750",
    x: 0.926758,
    y: 137.186,
    width: 370.511,
    height: 232.975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3241_36750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3241_36750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3241_36750",
    x1: 186.076,
    y1: 143.814,
    x2: 186.076,
    y2: 339.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCategoryEmpty);
export default __webpack_public_path__ + "static/media/product-category-empty.7fd4c75fb398bdb8eab318900e9d03d1.svg";
export { ForwardRef as ReactComponent };